import React, { useEffect } from "react";
import {
    analysis,
    boost,
    callOutgoing,
    challenge,
    dragDrop,
    group,
    groupOpen,
    homeMain,
    job,
    machineLearning,
    mbContent1,
    mbContent2,
    mbContent3_1,
    mbContent3_2,
    mbContent4,
    mbfederated1,
    mbfederated2,
    mbintroducing4,
    mbintroducing5,
    mbintroducing6,
    optimizeResources,
    phone,
    privateChat,
    strengthenCollaboration,
    syncPng,
    track,
} from "../../assets/images/image";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import {
    APP_STORE_QR,
    APP_STORE_URL,
    APP_URL,
    GOOGLE_PLAY_QR,
    GOOGLE_PLAY_URL,
} from "../../configs/default.config";
import { useTranslation } from "react-i18next";

const defaultReset = 7000;

const HomeMobile = () => {
    const { t } = useTranslation();
    const [positionContent, setPositionContent] = React.useState(1);
    const controls = useAnimation();
    const [, inView] = useInView({
        threshold: 0.1,
        triggerOnce: false
    });

    useEffect(() => {
        if (inView) {
            controls.start("visible");
        } else {
            controls.start("hidden");
        }
    }, [controls, inView]);

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                delayChildren: 0.3
            }
        }
    };

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                delayChildren: 0.3,
            }
        }
    };

    const fadeInVariants = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { duration: 0.8 } }
    };


    const slideInFromRight = {
        hidden: { x: 100, opacity: 0 },
        visible: { x: 0, opacity: 1, transition: { duration: 0.6 } }
    };

    const content = [
        {
            position: 1,
            url: [mbContent1],
            className: "w-full flex-shrink-0",
            text: t("homeMobile.content.badge1"),
        },
        {
            position: 2,
            url: [mbContent2],
            className: "w-full flex-shrink-0",
            text: t("homeMobile.content.badge2"),
        },
        {
            position: 3,
            url: [mbContent3_1, mbContent3_2],
            className: "w-full flex-shrink-0",
            text: t("homeMobile.content.badge3"),
        },
        {
            position: 4,
            url: [mbContent4],
            className: "w-full flex-shrink-0",
            text: t("homeMobile.content.badge4"),
        },
    ];

    React.useEffect(() => {
        const timeout = setTimeout(() => {
            setPositionContent((prev) => (prev < 4 ? prev + 1 : 1));
        }, defaultReset);

        return () => clearTimeout(timeout);
    }, [positionContent]);


    const workContent = [
        {
            position: 1,
            url: machineLearning,
            className: "w-[48px] h-[48px] flex-shrink-0",
            content: t("homeSections.work.items.0"),
        },
        {
            position: 2,
            url: dragDrop,
            className: "w-[48px] h-[48px] flex-shrink-0",
            content: t("homeSections.work.items.1"),
        },
        {
            position: 3,
            url: challenge,
            className: "w-[48px] h-[48px] flex-shrink-0",
            content: t("homeSections.work.items.2"),
        },
        {
            position: 4,
            url: analysis,
            className: "w-[48px] h-[48px] flex-shrink-0",
            content: t("homeSections.work.items.3"),
        },
        {
            position: 5,
            url: job,
            className: "w-[48px] h-[48px] flex-shrink-0",
            content: t("homeSections.work.items.4"),
        },
    ];

    const challengeContent = [
        {
            position: 1,
            url: boost,
            className: "w-[48px] h-[48px] flex-shrink-0",
            content: t("homeSections.challenge.items.0"),
        },
        {
            position: 2,
            url: strengthenCollaboration,
            className: "w-[48px] h-[48px] flex-shrink-0",
            content: t("homeSections.challenge.items.1"),
        },
        {
            position: 3,
            url: group,
            className: "w-[48px] h-[48px] flex-shrink-0",
            content: t("homeSections.challenge.items.2"),
        },
        {
            position: 4,
            url: optimizeResources,
            className: "w-[48px] h-[48px] flex-shrink-0",
            content: t("homeSections.challenge.items.3"),
        }
    ];

    const federatedContent = [
        {
            position: 1,
            className: "w-[48px] h-[48px] flex-shrink-0",
            content: t("homeSections.federated.items.0"),
        },
        {
            position: 2,
            className: "w-[48px] h-[48px] flex-shrink-0",
            content: t("homeSections.federated.items.1"),
        },
        {
            position: 3,
            className: "w-[48px] h-[48px] flex-shrink-0",
            content: t("homeSections.federated.items.2"),
        },
    ];

    return (
        <>
            <motion.div
                initial="hidden"
                animate="visible"
                variants={containerVariants}
                className="flex flex-col md:flex-row items-center justify-between mt-[73px]"
            >
                <motion.div variants={itemVariants} className="w-full px-6 text-center">
                    <p className="text-[24px] font-bold leading-[normal] text-[#B1B1B1]">
                        {t("homeMobile.hero.kicker")}
                    </p>
                </motion.div>
                <motion.div variants={itemVariants} className="w-full px-6 mt-[16px]">
                    <h1 className="text-[#494949] text-[26px] leading-[40px] font-[274]">
                        {t("homeMobile.hero.titleBefore")}{" "}
                        <span className="text-[#3A57FF] font-extrabold text-[26px] leading-[40px]">
                            {t("homeMobile.hero.titleHighlight")}
                        </span>{" "}
                        {t("homeMobile.hero.titleAfter")}
                    </h1>
                </motion.div>
                <motion.div variants={itemVariants} className="w-full px-6 mt-[16px]">
                    <p className="text-[#494949] text-[16px] leading-[24px] font-normal">
                        {t("homeMobile.hero.description")}
                    </p>
                </motion.div>
                <motion.img
                    className="w-full flex-shrink-0 mt-[16px]"
                    variants={slideInFromRight}
                    src={homeMain}
                    alt="Task automation mockup"
                />
                <motion.div variants={itemVariants} className="w-full px-6 mt-[16px]">
                    <button
                        onClick={() => window.location.href = APP_URL}
                        className="hidden inline-flex h-[53px] px-8 py-4 justify-center items-center gap-2 flex-shrink-0 rounded-[16px] bg-[#3A57FF] text-[17px] font-normal leading-[normal] text-[#FAFAFA] w-full">
                        <span className="flex items-center justify-center mb-1">{t("homeMobile.hero.primaryCta")} &nbsp;</span>
                        <img
                            src={groupOpen}
                            alt="Task automation mockup"
                            className="h-[13.87px] w-[11.39px]"
                        />
                    </button>
                </motion.div>
                <motion.div variants={itemVariants} className="w-full px-6 mt-[12px] flex flex-col gap-4">
                    <button
                        type="button"
                        onClick={() => { window.location.href = APP_STORE_URL; }}
                        className="w-full bg-white/80 border border-[#3A57FF] rounded-[24px] p-5 flex items-center gap-6 ultimate-shadow text-left transition-all duration-300 active:opacity-90"
                    >
                        <div className="flex flex-col gap-3 flex-1 min-w-0">
                            <div className="flex items-center gap-2">
                                <svg className="w-6 h-6 text-[#1e293b] flex-shrink-0" viewBox="0 0 384 512" fill="currentColor" aria-hidden="true">
                                    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
                                </svg>
                                <span className="text-[13px] font-bold text-blue-600 uppercase tracking-tight">
                                    {t("homeMobile.storeCards.apple")}
                                </span>
                            </div>
                            <div>
                                <h3 className="text-lg font-bold text-slate-800 tracking-tight">
                                    {t("homeMobile.storeCards.appStore")}
                                </h3>
                                <p className="text-[11px] text-slate-500 font-medium">
                                    {t("homeMobile.storeCards.iosDownload")}
                                </p>
                            </div>
                        </div>
                        <div className="w-20 h-20 flex-shrink-0 bg-white border border-slate-100 rounded-2xl p-1.5 shadow-sm">
                            <img
                                src={APP_STORE_QR}
                                alt={t("homeMobile.storeCards.appStore")}
                                className="w-full h-full rounded-xl object-cover"
                            />
                        </div>
                    </button>

                    <button
                        type="button"
                        onClick={() => { window.location.href = GOOGLE_PLAY_URL; }}
                        className="w-full bg-white/80 border border-[#3A57FF] rounded-[24px] p-5 flex items-center gap-6 ultimate-shadow text-left transition-all duration-300 active:opacity-90"
                    >
                        <div className="flex flex-col gap-3 flex-1 min-w-0">
                            <div className="flex items-center gap-2">
                                <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1z" fill="#EA4335" />
                                    <path d="M104.6 499l220.7-220.7 60.1 60.1L104.6 499z" fill="#FBBC04" />
                                    <path d="M104.6 13v486l220.7-220.7L104.6 13z" fill="#4285F4" />
                                    <path d="M385.4 174.2L104.6 13v486l280.8-161.2 56.4-32.4c10.1-5.8 10.1-20.3 0-26.1l-56.4-32.1z" fill="#34A853" />
                                </svg>
                                <span className="text-[13px] font-bold text-blue-600 uppercase tracking-tight">
                                    {t("homeMobile.storeCards.googlePlay")}
                                </span>
                            </div>
                            <div>
                                <h3 className="text-lg font-bold text-slate-800 tracking-tight">
                                    {t("homeMobile.storeCards.playStore")}
                                </h3>
                                <p className="text-[11px] text-slate-500 font-medium">
                                    {t("homeMobile.storeCards.androidDownload")}
                                </p>
                            </div>
                        </div>
                        <div className="w-20 h-20 flex-shrink-0 bg-white border border-slate-100 rounded-2xl p-1.5 shadow-sm">
                            <img
                                src={GOOGLE_PLAY_QR}
                                alt={t("homeMobile.storeCards.playStore")}
                                className="w-full h-full rounded-xl object-cover"
                            />
                        </div>
                    </button>
                </motion.div>
                <motion.div variants={itemVariants} className="w-full px-6 mt-[16px]">
                    <button onClick={() => window.location.href = "/contact"} className="inline-flex h-[53px] px-8 py-4 justify-center items-center gap-2 flex-shrink-0 rounded-[16px] border border-[#3A57FF] text-[17px] font-normal leading-[normal] text-[#494949] w-full">
                        <span className="flex items-center justify-center mb-1">{t("homeMobile.hero.secondaryCta")} &nbsp;</span>
                        <img
                            src={callOutgoing}
                            alt="Task automation mockup"
                            className="h-[24px] w-[24px]"
                        />
                    </button>
                </motion.div>
                <motion.div variants={slideInFromRight} className="w-full px-6 mt-[32px] text-[#494949] text-[26px] leading-[40px] font-[274]">
                    {t("homeMobile.intro.title")}
                </motion.div>
                <motion.div variants={slideInFromRight} className="w-full px-6 text-[#494949] text-[16px] leading-[24px] font-normal mt-[16px]">
                    {t("homeMobile.intro.sectors")}
                </motion.div>
                <motion.div variants={slideInFromRight} className="w-full px-6 text-[#494949] text-[16px] leading-[24px] font-normal mt-[16px]">
                    {t("homeMobile.intro.description")}
                </motion.div>
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={fadeInVariants}
                    className="w-full px-6"
                >
                    {content.map((item, index) => (
                        <div key={index}>
                            <motion.div variants={itemVariants} className="w-full text-center mt-[70px] mb-[32px]">
                                <div className="w-full inline-flex h-[56px] px-4 py-1 justify-center items-center gap-4 flex-shrink-0 bg-[#3A57FF] text-[#FAFAFA] text-center text-[#FAFAFA] text-[16px] leading-[24px] font-bold">
                                    {item.text}
                                </div>
                            </motion.div>
                            {item.url.map((url, i) => (
                                <motion.img
                                    key={`url-${i}`}
                                    className={`${item.className} ${i !== item.url.length - 1 ? "mb-[40px]" : ""}`}
                                    variants={slideInFromRight}
                                    src={url}
                                    alt="Task automation mockup"
                                />
                            ))}
                        </div>
                    ))}
                </motion.div>
                <motion.div variants={itemVariants} className="w-full px-6 mt-[32px] text-[#494949] text-[26px] leading-[40px] font-[274]">
                    {t("homeSections.work.title")}
                </motion.div>
                <motion.div
                    variants={containerVariants}
                    className="flex flex-col w-full px-6"
                >
                    {workContent.map((item) => (
                        <motion.div
                            key={item.position}
                            variants={itemVariants}
                            className="flex flex-row items-center gap-3 w-full h-auto"
                        >
                            <div className="flex items-center justify-center">
                                <img src={item.url} className={item.className} alt={`icon-${item.position}`} />
                            </div>
                            <div className="w-full ps-2" dangerouslySetInnerHTML={{ __html: item.content }} />
                        </motion.div>
                    ))}
                </motion.div>
                <motion.div variants={itemVariants} className="w-full px-6 mt-[32px] text-[#494949] text-[26px] leading-[40px] font-[274]">
                    {t("homeSections.challenge.title")}
                </motion.div>
                <motion.div
                    variants={containerVariants}
                    className="flex flex-col w-full px-6"
                >
                    {challengeContent.map((item) => (
                        <motion.div
                            key={item.position}
                            variants={itemVariants}
                            className="flex flex-row items-center gap-3 w-full h-auto"
                        >
                            <div className="flex items-center justify-center">
                                <img src={item.url} className={item.className} alt={`icon-${item.position}`} />
                            </div>
                            <div className="w-full ps-2" dangerouslySetInnerHTML={{ __html: item.content }} />
                        </motion.div>
                    ))}
                </motion.div>
                <motion.div variants={itemVariants} className="w-full px-6 mt-[32px] text-[#494949] text-[26px] leading-[40px] font-[274]">
                    {t("homeSections.federated.title")}
                </motion.div>
                <motion.div variants={itemVariants} className="w-full px-6 mt-[16px] text-[#3A57FF] text-[16px] font-[274]">
                    {t("homeSections.federated.subtitle")}
                </motion.div>
                <motion.div variants={itemVariants} className="w-full px-6 text-[#494949] text-[16px] font-[274]">
                    {t("homeSections.federated.description")}
                </motion.div>

                {[mbfederated1, mbfederated2].map((item, index) => (
                    <motion.img
                        key={index}
                        className="w-full flex-shrink-0 mt-[50px] px-6"
                        variants={slideInFromRight}
                        src={item}
                        alt={item}
                    />
                ))}
                <motion.div
                    variants={containerVariants}
                    className="flex flex-col w-full px-6"
                >
                    {federatedContent.map((item) => (
                        <motion.div
                            key={item.position}
                            variants={itemVariants}
                            className="flex flex-row items-center gap-3 w-full h-auto"
                        >
                            <div className="w-full ps-2" dangerouslySetInnerHTML={{ __html: item.content }} />
                        </motion.div>
                    ))}
                </motion.div>
                <motion.div variants={itemVariants} className="w-full px-6 mt-[32px] text-[#494949] text-[26px] leading-[40px] font-[274]">
                    {t("homeSections.chat.title")}
                </motion.div>
                <motion.div
                    variants={slideInFromRight}
                    className="w-[100%] flex-shrink-0 p-8"
                >
                    <div className="text-[#5a5a5a] text-[16px] font-normal leading-[1.6] mb-8">
                        <p className="text-[#494949] text-[16px] font-normal leading-[24px] mt-[8px]" dangerouslySetInnerHTML={{ __html: t("homeSections.chat.description") }} />
                    </div>

                    <div className="space-y-6">
                        <div className="bg-[#E7E7E7] rounded-[16px] p-6">
                            <div className="flex items-center gap-4">
                                <div className="flex-shrink-0 w-8 flex items-center justify-center">
                                    <img
                                        src={privateChat}
                                        alt="Private Chat"
                                        className="w-10 h-10 object-contain"
                                    />
                                </div>
                                <div className="text-[#5a5a5a] text-[16px] font-normal">
                                    <div className="mb-1">
                                        <strong>{t("homeSections.chat.cards.private.title")}</strong>
                                    </div>
                                    <div>
                                        {t("homeSections.chat.cards.private.description")}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="bg-[#E7E7E7] rounded-[16px] p-6">
                            <div className="flex items-center gap-4">
                                <div className="flex-shrink-0 w-8 flex items-center justify-center">
                                    <img
                                        src={syncPng}
                                        alt="Live Sync"
                                        className="w-10 h-10 object-contain"
                                    />
                                </div>
                                <div className="text-[#5a5a5a] text-[16px] font-normal">
                                    <div className="mb-1">
                                        <strong>{t("homeSections.chat.cards.sync.title")}</strong>
                                    </div>
                                    <div>
                                        {t("homeSections.chat.cards.sync.description")}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="bg-[#E7E7E7] rounded-[16px] p-6">
                            <div className="flex items-center gap-4">
                                <div className="flex-shrink-0 w-8 flex items-center justify-center">
                                    <img
                                        src={track}
                                        alt="Track"
                                        className="w-10 h-10 object-contain"
                                    />
                                </div>
                                <div className="text-[#5a5a5a] text-[16px] font-normal">
                                    <div className="mb-1">
                                        <strong>{t("homeSections.chat.cards.track.title")}</strong>
                                    </div>
                                    <div>
                                        {t("homeSections.chat.cards.track.description")}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.div>
                {[mbintroducing4, mbintroducing5, mbintroducing6].map((item, index) => (
                    <motion.img
                        key={index}
                        className="w-full flex-shrink-0 mt-[50px] px-6"
                        variants={slideInFromRight}
                        src={item}
                        alt={item}
                    />
                ))}
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={containerVariants}
                    className="w-full px-6"
                >
                    <motion.div variants={itemVariants} className="text-[#494949] text-[26px] leading-[40px] font-[274] mt-[64px]">
                        {t("homeSections.roi.mobileTitleBefore")} <span className="text-[#3A57FF] font-bold">{t("homeSections.roi.mobileTitleHighlight")}</span>
                    </motion.div>
                    <motion.div variants={itemVariants} className="text-[#494949] text-[26px] leading-[40px] font-normal mt-[32px]">
                        {t("homeSections.roi.mobileSubtitle")}
                    </motion.div>
                    <motion.div variants={itemVariants} className="text-[#494949] text-[16px] leading-[24px] font-normal mt-[16px]">
                        <span className="text-[#3A57FF] font-bold">{t("homeSections.roi.outputLabel")} </span>{t("homeSections.roi.outputText")}
                    </motion.div>
                    <motion.img
                        className="w-full flex-shrink-0 mt-[32px]"
                        variants={slideInFromRight}
                        src={phone}
                        alt="Task automation mockup"
                    />
                    <motion.div className="flex flex-col w-full h-auto bg-[#3A57FF] mt-[32px] justify-center">
                        <div className="p-2 max-w-md mx-auto">
                            <ul className="text-[#FAFAFA] text-[16px] leading-[24px] font-bold">
                                <li className="flex items-center">
                                    <span>{t("homeSections.roi.mobileList.0")}</span>
                                </li>
                                <li className="flex items-center">
                                    <span>{t("homeSections.roi.mobileList.1")}</span>
                                </li>
                                <li className="flex items-center">
                                    <span>{t("homeSections.roi.mobileList.2")}</span>
                                </li>
                            </ul>
                        </div>
                    </motion.div>
                    <motion.div className="flex justify-center p-4 space-x-4 mt-[32px]">
                        <h1 className="text-[#494949] text-center font-inter text-[64px] font-bold leading-none">
                            $20
                        </h1>
                        <div className="text-right mt-1">
                            <h2 className="ms-2 text-[#3A57FF] text-center text-[24px] font-bold leading-none">
                                {t("homeSections.roi.planName")}
                            </h2>
                            <p className="text-[#494949] text-[32px] font-normal leading-none font-inter">
                                {t("homeSections.roi.perMonth")}
                            </p>
                        </div>
                    </motion.div>
                    <motion.div variants={itemVariants} className="w-full mt-[32px]">
                        <button
                            onClick={() => window.location.href = APP_URL}
                            className="inline-flex h-[53px] px-8 py-4 justify-center items-center gap-2 flex-shrink-0 rounded-[16px] bg-[#3A57FF] text-[17px] font-normal leading-[normal] text-[#FAFAFA] w-full">
                            <span className="flex items-center justify-center mb-1 whitespace-nowrap">{t("homeSections.roi.cta")} &nbsp;</span>
                            <img
                                src={groupOpen}
                                alt="Task automation mockup"
                                className="h-[13.87px] w-[11.39px]"
                            />
                        </button>
                    </motion.div>
                </motion.div>
            </motion.div>
        </>
    );
};

export default HomeMobile;